import { defineStore } from "pinia";
import _ from "lodash";
import * as _debug from "debug";
import ApiClient from "@/lib/ApiClient";
import { sureClone } from "@/lib/DataUtils";
import { createStore } from "../storeHelper";

const debug = _debug(`${process.env.VUE_APP_PREFIX}:VesselsStore`);

const DEFAULT_EDITOR = {
  id: null,
  name: null,
  organisationId: null,
};

export const useVesselsStore = defineStore(
  "vessels",
  createStore({
    state: {
      vessels: {},
      editor: sureClone(DEFAULT_EDITOR),
    },

    getters: {
      vesselsList: (state) => _.values(state.vessels),
      vesselsInOrganisation: (state) => (organisationId) => {
        return _.values(state.vessels).filter(
          (x) => x.organisationId === organisationId,
        );
      },
      editorChanges() {
        return this.getEditorChanges("vessels");
      },
      editorHasChanges() {
        const diff = this.editorChanges;
        return diff && !_.isEmpty(diff);
      },
    },

    actions: {
      newVesselToEditor() {
        this.set("editor", sureClone(DEFAULT_EDITOR));
      },

      addVessel(vessel) {
        this.vessels[vessel.id] = vessel;
      },

      deleteVessel(vesselId) {
        delete this.vessels[vesselId];
      },

      async load() {
        debug("load");
        // Note: Original loads from /collections endpoint
        const vessels = await ApiClient.get(`/collections`);
        debug("load", vessels);
        this.set("vessels", _.keyBy(vessels, "id"));
      },

      async loadVesselToEditor(vesselId) {
        debug("loadVesselToEditor", vesselId);
        const vessel = this.vessels[vesselId];
        if (!vessel) {
          throw new Error("Vessel not found");
        }
        this.set("editor", sureClone(vessel));
      },

      async saveVesselInEditor() {
        if (!this.editorHasChanges) {
          debug("saveVesselInEditor", "No changes to save");
          return;
        }

        const vesselId = this.editor.id;
        const result = await ApiClient.put(
          `/collections/${vesselId}`,
          this.editor,
        );

        if (result) {
          this.addVessel(result);
        }
        return result;
      },
    },
  }),
);
